// Code generated by gen-i18n. DO NOT EDIT.

const translations = {
    'en': {
        'contactNoteSentClose': 'Close',
        'contactFormPaymentQuestion': 'Payment/Billing Question',
        'contactFormSubmitNote': 'Submit Note',
        'footerCompany': 'Company',
        'footerSupport': 'Support',
        'footerAllProducts': 'All Products',
        'footerGovernment': 'Government',
        'footerNonProfit': 'Non-Profit',
        'contactAvailableDuringBusinessHours': '*We are available during our business hours:',
        'contactCardsEmailUs': 'Email Us',
        'contactCardsTalkToARealPerson': 'Talk or text a real person! We are happy to chat if you use the phone number below!',
        'footerProducts': 'Products',
        'footerAboutUs': 'About Us',
        'footerEducation': 'Education',
        'contactBusinessHours': '8:30 AM – 6:30 PM (EST)',
        'contactCardsTextNow': 'Text Now',
        'contactCardsAvailableDuringBusinessHours': 'We are available during our business hours*',
        'contactFormContactDetails': 'Contact details to help us get in touch with you',
        'formEmail': 'Email',
        'footerAllRightsReserved': 'All rights reserved',
        'footerLapelPins': 'Lapel Pins',
        'contactCardsCallNow': 'Call Now',
        'contactFormReason': 'Reason',
        'contactFormPreferredContactMethod': 'Preferred contact method: ',
        'formAttachments': 'Attachments',
        'formFullName': 'Full Name',
        'formYourPhoneNumber': 'Your phone number...',
        'contactIn': 'Contact in English',
        'contactNoteSentMessage': 'Your note has been sent. We will get back to you within one business day.',
        'contactFormArtworkOrDesignAssistance': 'Artwork Or Design Assistance',
        'formYourNotesAndRequests': 'Your notes and requests...',
        'headerFindWhatYouNeed': 'Find what you need...',
        'headerPricing': 'Pricing',
        'headerAllProducts': 'All Products',
        'footerFAQ': 'FAQ',
        'contactCardsReachOut': 'Reach out via e-mail to the address below',
        'contactFormNewDesign': 'New Custom Design',
        'formYourFullName': 'Your full name...',
        'uploadDeleteConfirm': 'Are you sure you want to delete this file?',
        'submit': 'Submit',
        'footerPricing': 'Pricing',
        'footerGallery': 'Gallery',
        'footerMedical': 'Medical',
        'contactCardsOpenEmailClient': 'Open Email Client',
        'contactFormOrderStatusOrShippingInquiry': 'Order Status or Shipping Inquiry',
        'contactFormReasonSelected': 'Reason selected: ',
        'formOptional': 'optional',
        'footerTermsAndConditions': 'Terms & Conditions',
        'footerPrivacy': 'Privacy',
        'contactViewMoreSocialMedia': 'View More on any of our social media sites',
        'contactNoteSentTitle': 'Note Sent!',
        'contactCardsCopyEmail': 'Copy Email',
        'formYourEmailAddress': 'Your email address...',
        'formCall': 'Call',
        'formText': 'Text',
        'footerEnterYourEmail': 'Enter your email to receive updates and offers!',
        'footerProductUses': 'Product Uses',
        'formOrg': 'Organization',
        'formNo': 'No',
        'headerFreeFreeFree': 'FREE Shipping! FREE Artwork! and Unlimited Revisions!',
        'headerGallery': 'Gallery',
        'headerPlaceOrder': 'Place Order',
        'footerResources': 'Resources',
        'footerContactUs': 'Contact Us',
        'contactBusinessWeekdays': 'Mon - Fri',
        'contactViewOurSocialMedia': 'View Our Social Media',
        'contactCardsWantToHaveAChat': 'Want to have a chat with us right here? Use the button below to message us now!',
        'formHowWouldYouLikeContact': 'How would you like us to contact you?',
        'uploadDescShort': 'click here to add files',
        'footerPatches': 'Patches',
        'footerPolice': 'Police',
        'contactCardsRespondInOneDay': 'We will respond within one business day',
        'contactFormWhatIsYourMessage': 'What would you like us to know?',
        'formComments': 'Comments',
        'formYes': 'Yes',
        'uploadDesc': 'Drag and drop or click here to add files',
        'headerYourAccount': 'Your Account',
        'footerIndustry': 'Industry',
        'footerWhoWeDeliverWith': 'Who we deliver with',
        'footerDiscover': 'Discover',
        'contactFormPartnershipOrWholesaleInquiry': 'Partnership or Wholesale Inquiry',
        'headerDiscover': 'Discover',
        'headerExplore': 'Explore',
        'footerLanyards': 'Lanyards',
        'contactWaysToConnect': 'Ways to Connect',
        'contactCardsChatWithUs': 'Chat with Us',
        'contactFormRequestQuote': 'Request a Quote',
        'search': 'Search',
        'footerCorporate': 'Corporate',
        'contactSendUsANote': 'Send Us a Note',
        'contactCardsOpenLiveChat': 'Open Live Chat',
        'contactCardsTextOrCall': 'Text or Call Us',
        'contactFormReorderOrUpdate': 'Reorder or Update Existing Design',
        'uploadLoading': 'Loading...',
        'recaptchaNotice': '<small class="text-muted">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</small>',
        'footerMilitary': 'Military',
        'contactFormSelectReason': 'Select a reason...',
        'contactFormGeneralInformation': 'General Information or Feedback',
        'formYourOrgName': 'Your organization/company name...',
        'headerProducts': 'Products',
        'headerShopNow': 'Shop Now',
        'footerChallengeCoins': 'Challenge Coins',
        'contactSendANote': 'Send a Note',
        'formPhone': 'Phone',
        'headerContactUs': 'Contact Us',
        'headerCustomizeNow': 'Customize Now',
        'headerQuoteLookup': 'Quote Lookup',
        'footerFollowUs': 'Follow Us!',
        'footerPaymentMethodsWeAccept': 'Payment methods we accept',
        'footerAccount': 'Account',
        'footerFirefighter': 'Firefighter',
        'contactClickToSendNote': 'Click the link below to send us a note. We will get back to you in 1 business day!',
    },
    'es': {
        'footerTermsAndConditions': 'Términos y Condiciones',
        'contactFormReason': 'Razón',
        'contactFormArtworkOrDesignAssistance': 'Asistencia con arte o diseño',
        'formCall': 'Llamar',
        'headerProducts': 'Productos',
        'footerPrivacy': 'Privacidad',
        'footerAccount': 'Cuenta',
        'contactBusinessHours': '09.00am – 06:30pm (EST)',
        'contactClickToSendNote': 'Haz clic en el enlace de abajo para enviarnos una nota. ¡Te responderemos dentro de un día hábil!',
        'contactCardsOpenEmailClient': 'Abrir cliente de correo',
        'contactCardsCopyEmail': 'Copiar correo electrónico',
        'contactFormPaymentQuestion': 'Pregunta de pago/facturación',
        'headerAllProducts': 'Todos los productos',
        'footerPaymentMethodsWeAccept': 'Métodos de pago que aceptamos',
        'footerWhoWeDeliverWith': 'Con quién entregamos',
        'contactFormGeneralInformation': 'Información general o comentarios',
        'formEmail': 'Email',
        'formYes': 'Sí',
        'contactWaysToConnect': 'Formas de Conectarse',
        'contactCardsAvailableDuringBusinessHours': 'Estamos disponibles durante nuestro horario laboral*',
        'contactFormOrderStatusOrShippingInquiry': 'Estado del pedido o consulta de envío',
        'contactFormPartnershipOrWholesaleInquiry': 'Consulta de asociación o venta al por mayor',
        'formYourEmailAddress': 'Tu dirección de correo electrónico...',
        'uploadLoading': 'Cargando...',
        'headerFindWhatYouNeed': 'Encuentra lo que necesitas...',
        'contactCardsTalkToARealPerson': '¡Habla o envía mensajes de texto a una persona real! Estaremos encantados de conversar si usas el número de teléfono de abajo.',
        'footerPatches': 'Parches',
        'footerAboutUs': 'Sobre nosotros',
        'footerMedical': 'Médico',
        'contactCardsRespondInOneDay': 'Te responderemos dentro de un día hábil',
        'contactCardsCallNow': 'Llamar ahora',
        'headerGallery': 'Galería',
        'footerGallery': 'Galería',
        'footerChallengeCoins': 'Monedas de desafío',
        'contactAvailableDuringBusinessHours': 'Estamos disponibles durante nuestro horario comercial:',
        'contactViewOurSocialMedia': 'Ver nuestras redes sociales',
        'contactCardsReachOut': 'Comunícate por correo electrónico a la dirección que aparece a continuación',
        'uploadDeleteConfirm': '¿Estás seguro de que deseas eliminar este archivo?',
        'footerPricing': 'Precios',
        'contactSendUsANote': 'Envíanos una nota',
        'contactNoteSentTitle': '¡Nota enviada!',
        'contactCardsEmailUs': 'Envíanos un correo electrónico',
        'contactFormRequestQuote': 'Solicitar una cotización',
        'contactFormNewDesign': 'Nuevo diseño personalizado',
        'formNo': 'No',
        'footerFollowUs': '¡Síguenos!',
        'footerLapelPins': 'Pines de solapa',
        'footerPolice': 'Policía',
        'contactIn': 'Contacto en Español',
        'contactCardsChatWithUs': 'Chatea con nosotros',
        'headerExplore': 'Explora',
        'footerCompany': 'Compañía',
        'footerAllProducts': 'Todos los productos',
        'footerGovernment': 'Gobierno',
        'contactCardsWantToHaveAChat': '¿Quieres chatear con nosotros aquí mismo? ¡Usa el botón de abajo para enviarnos un mensaje ahora!',
        'contactCardsTextOrCall': 'Envíanos un mensaje de texto o llámanos',
        'formOptional': 'opcional',
        'formAttachments': 'Archivos adjuntos',
        'formYourFullName': 'Tu nombre completo...',
        'contactNoteSentClose': 'Cerrar',
        'formYourNotesAndRequests': 'Tus notas y solicitudes...',
        'formYourOrgName': 'El nombre de tu organización...',
        'uploadDesc': 'Arrastra o haz clic para subir archivos',
        'headerPricing': 'Precios',
        'headerContactUs': 'Contáctanos',
        'headerCustomizeNow': 'Personaliza ahora',
        'headerShopNow': 'Compra ahora',
        'search': 'Buscar',
        'footerCorporate': 'Corporativo',
        'footerFirefighter': 'Bomberos',
        'contactBusinessWeekdays': 'Lunes - Viernes',
        'contactCardsTextNow': 'Enviar mensaje ahora',
        'contactFormSubmitNote': 'Enviar nota',
        'contactFormReasonSelected': 'Razón seleccionada: ',
        'formComments': 'Comentarios',
        'footerEducation': 'Educación',
        'footerMilitary': 'Militar',
        'contactFormSelectReason': 'Seleccione una razón...',
        'contactFormContactDetails': 'Detalles de contacto para poder comunicarnos contigo',
        'formOrg': 'Organización',
        'formPhone': 'Teléfono',
        'formText': 'Texto',
        'headerDiscover': 'Descubre',
        'footerResources': 'Recursos',
        'footerSupport': 'Soporte',
        'footerFAQ': 'Preguntas frecuentes',
        'footerNonProfit': 'Sin fines de lucro',
        'contactSendANote': 'Enviar una nota',
        'contactViewMoreSocialMedia': 'Ver más en cualquiera de nuestras redes sociales',
        'headerPlaceOrder': 'Realizar pedido',
        'headerYourAccount': 'Tu cuenta',
        'footerContactUs': 'Contáctanos',
        'footerProducts': 'Productos',
        'footerIndustry': 'Industria',
        'footerAllRightsReserved': 'Todos los derechos reservados',
        'footerDiscover': 'Descubre',
        'footerLanyards': 'Cintas',
        'contactNoteSentMessage': 'Tu nota ha sido enviada. Nos pondremos en contacto contigo dentro de un día hábil.',
        'contactFormWhatIsYourMessage': '¿Qué te gustaría que supiéramos?',
        'submit': 'Enviar',
        'contactCardsOpenLiveChat': 'Abrir chat en vivo',
        'contactFormReorderOrUpdate': 'Reordenar o actualizar diseño existente',
        'contactFormPreferredContactMethod': 'Método de contacto preferido: ',
        'formFullName': 'Nombre completo',
        'formHowWouldYouLikeContact': '¿Cómo prefieres que te contactemos?',
        'headerFreeFreeFree': '¡Envío GRATIS! ¡Arte GRATIS! y Revisiones Ilimitadas!',
        'headerQuoteLookup': 'Buscar cotización',
        'footerEnterYourEmail': '¡Introduce tu correo electrónico para recibir actualizaciones y ofertas!',
        'footerProductUses': 'Usos de productos',
        'formYourPhoneNumber': 'Tu número de teléfono...',
        'uploadDescShort': 'Clic para subir archivos',
        'recaptchaNotice': '<small class="text-muted">Este sitio está protegido por reCAPTCHA y la <a href="https://policies.google.com/privacy">Política de Privacidad</a> y los <a href="https://policies.google.com/terms">Términos de Servicio</a> de Google se aplican.</small>',
    },
};

type langs = keyof typeof translations;

type keys = {
    [L in langs]: keyof typeof translations[L]
}[langs]

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function i18n(key: keys): string {
    const lang = document.documentElement.lang as langs;
    return translations[lang][key];
}
